@if(downloadableFileSet) {
  <div class="border border-success rounded">
  
    <div class="row mb-0">
      <div class="col-12">
        <div class="alert border-0 alert-primary mb-0 text-center" role="alert">
          <strong><span class="fs-4" [innerHtml]="downloadableFileSet.webTitle"></span></strong>
        </div>
      </div>
    </div>
  
    @if(downloadableFileSet.webImageDownload!.fileContents) {
      <div class="row mt-0">
        <div class="col-12">
          <div class="download-image-container">
            <img
            #imgRef
            [src]="'data:image/png;base64,' + downloadableFileSet.webImageDownload!.fileContents"
            alt="Loaded Image"
            class="img-fluid w-100"
            (load)="onImageLoad(imgRef)"
           />
          </div>
        </div>
      </div>
    }
    
    <div class="row">
      <div class="col-12">
        <div id="textBlock" class="text-white d-flex align-items-center justify-content-center text-center" style="min-height: 150px;">
          <span class="fs-4" [innerHtml]="downloadableFileSet.webText"></span>
        </div>
      </div>
    </div>

    <div class="row g-0">
      <div class="col-12">
        <button
          class="btn btn-primary w-100 border border-success rounded-0"
          style="border-width: 1px 1px 1px 1px; border-top: none;"
          (click)="downloadFile()"
        >
          Download
        </button>
      </div>
    </div>
  
  </div>
}
